const config = {
    server: {
        endpoint: 'https://test.supporter.kulkos.net/api/'
    }
};

export default config;